module.exports = __webpack_public_path__ + "static/media/Passo3.d22d5fcf.d22d5fcf.JPG";